import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: 'LitbuySpreadsheets',
        description: 'Litbuy Spreadsheet guides, comparisons, tutorials, safety information, and expert resources.',
        publisher: {
          '@type': 'Organization',
          name: 'LitbuySpreadsheets',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        '@id': `${siteUrl}/#faq`,
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is Litbuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Litbuy Spreadsheet is a modern spreadsheet platform that offers powerful data management, automation, and collaboration features. It is designed to help both beginners and advanced users work more efficiently with data through an intuitive interface, pre-built templates, and smart automation tools.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is Litbuy Spreadsheet safe to use?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, Litbuy Spreadsheet follows industry-standard security practices to protect user data. All information is encrypted during transmission, and the platform includes access controls, version history, and regular security updates.',
            },
          },
          {
            '@type': 'Question',
            name: 'How does Litbuy Spreadsheet compare to Excel and Google Sheets?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Litbuy Spreadsheet offers several advantages over traditional spreadsheet tools including built-in automation workflows, a more intuitive template system, and streamlined collaboration features.',
            },
          },
          {
            '@type': 'Question',
            name: 'Who can benefit from using Litbuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Litbuy Spreadsheet is suitable for small business owners tracking inventory, freelancers managing project budgets, students organizing research data, and teams collaborating on shared reports.',
            },
          },
          {
            '@type': 'Question',
            name: 'Are there templates available for Litbuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, Litbuy Spreadsheet provides a rich library of pre-built templates covering use cases such as budgeting, project management, inventory tracking, expense reporting, scheduling, and data analysis.',
            },
          },
          {
            '@type': 'Question',
            name: 'Where can I learn more about Litbuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'You can explore comprehensive guides and articles on this website covering everything from getting started to advanced tips and comparisons.',
            },
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        '@id': `${siteUrl}/#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: siteUrl,
          },
        ],
      },
    ];

    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      const staleArticleSchema = document.getElementById('schema-jsonld');
      if (staleArticleSchema) {
        staleArticleSchema.remove();
      }
    };
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategorySection />
      <AboutSection />
      <ArticleSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}